import { toast } from "@/components/ui/use-toast";
import { Tags } from "@/enum/tags";
import { apiSlice } from "@/services/http";
import { useReprocessConciliationMutation } from "@/services/store-conciliation";
import { Loader2 } from "lucide-react";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

interface SyncProcessingFlowProps {
  onComplete: () => void;
  transactionId: string;
}

export const SyncProcessingFlow = ({ onComplete, transactionId }: SyncProcessingFlowProps) => {
  const dispatch = useDispatch();
  const [reprocessConciliation] = useReprocessConciliationMutation();
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (hasStartedRef.current) return;
    hasStartedRef.current = true;
    if (!transactionId) {
      console.error("Sem id de transacao!");
      toast({
        variant: "destructive",
        description: "Erro: ID de transacao nao encontrado",
        duration: 5000,
      });
      onComplete();
      return;
    }

    dispatch(
      apiSlice.util.invalidateTags([
        Tags.NSU,
        Tags.ACCOUNTING_ACCOUNT,
        Tags.CAN_CLOSE_CONCILIATION,
        Tags.STORE_CONCILIATION,
        Tags.DIVERGENCE,
      ])
    );

    reprocessConciliation({ id: parseInt(transactionId, 10) })
      .unwrap()
      .then(() => {
        toast({
          variant: "default",
          description: "Reprocessado com Sucesso!",
          duration: 5000,
        });
        onComplete();
      })
      .catch((error: any) => {
        console.error(error);
        toast({
          variant: "destructive",
          description: "Algo deu Errado!",
          duration: 5000,
        });
        onComplete();
      });
  }, [transactionId, reprocessConciliation, dispatch, onComplete]);

  return (
    <>
      Por favor, aguarde enquanto a conciliacao esta sendo reprocessada.
      <div className="py-1 space-y-4 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 p-6">
          <Loader2 className="h-12 w-12 animate-spin" />
          <p className="text-sm text-gray-600 italic text-center">
            Os dados serao atualizados automaticamente quando concluido.
          </p>
        </div>
      </div>
    </>
  );
};
